module.exports = __webpack_public_path__ + "static/img/11.8c2f05b3.jpg";